<div class="user-detail">
  <div class="header mt-3 mb-53">
    <div class="d-flex justify-content-between">
      <img
        src="/assets/svg/ico-chevron-back-outline.svg"
        alt="back button"
        class="pointer-cursor"
        *ngIf="stepper > 1"
        (click)="navigateBack()"
      />

      <h1 class="modal-title m-auto">{{ 'USERNAME' | translate }}</h1>

      <!-- dynamic back button render -->
      <ng-content select="[backButton]"></ng-content>
    </div>
  </div>
  <form [formGroup]="formGroup" (ngSubmit)="submit()" novalidate>
    <div
      class="form-inline md-form form-sm form-control form-control-sm px-2 my-4 search-field"
    >
      <img
        class="d-inline pointer-cursor"
        src="assets/svg/ico-search.svg"
        (click)="submit()"
      />
      <input
        class="field ml-2 w-75"
        type="text"
        [placeholder]="'SEARCH_FOR_KEYWORDS' | translate"
        aria-label="Search"
        formControlName="searchEntity"
        mdbInput
      />
      <img
        *ngIf="formGroup?.controls?.searchEntity.value.length > 0"
        class="d-inline pointer-cursor search-cross"
        src="assets/svg/ico-hamburger-close.svg"
        (click)="removeUser()"
      />
    </div>

    <div class="row mt-388">
      <div class="col-12">
        <button class="btn btn-danger px-3 w-100 btn-submit" type="submit">
          {{ 'CONTINUE' | translate }}
        </button>
      </div>
    </div>
  </form>
</div>
